import React from "react";

import { Popover, Button, Menu, MenuItem, Position } from "@blueprintjs/core";

import classNames from "classnames";
import styles from "./OrderListTableComponents.module.scss";

const stringRenderer = ({ className, value }) => (
  <div className={classNames(className, styles.cellText)}>{value}</div>
);

const emailRenderer = ({ className, value }) => (
  <a
    href={`mailto:${value}`}
    className={classNames(className, styles.emailLink, styles.cellText)}
  >
    {value}
  </a>
);

const statusRenderer = ({
  className,
  value,
  row: { values },
  onStatusChange
}) => (
  <Popover minimal position={Position.BOTTOM_LEFT}>
    <Button
      className={classNames(className, !!styles[value] && styles[value])}
      minimal
    >
      {value}
    </Button>

    <Menu>
      <MenuItem
        active={value === "Pending"}
        text="Pending"
        onClick={() => {
          if (value !== "Pending") {
            onStatusChange({ status: "Pending", id: values.id });
          }
        }}
      />
      <MenuItem
        active={value === "Processing"}
        text="Processing"
        onClick={() => {
          if (value !== "Processing") {
            onStatusChange({ status: "Processing", id: values.id });
          }
        }}
      />
      <MenuItem
        active={value === "Fulfilled"}
        text="Fulfilled"
        onClick={() => {
          if (value !== "Fulfilled") {
            onStatusChange({ status: "Fulfilled", id: values.id });
          }
        }}
      />
    </Menu>
  </Popover>
);

const renderers = {
  string: stringRenderer,
  email: emailRenderer,
  status: statusRenderer
};

const Cell = ({ onStatusChange }) => ({ cell, ...props }) => {
  const format = cell.column.dataKey || "string";
  const renderer = renderers[format] || renderers.string;

  return renderer({ ...cell, ...props, onStatusChange });
};

export default Cell;
